import { registerPlugin } from '@capacitor/core';

import type { CalendarPluginPlugin } from './definitions';

const CalendarPlugin = registerPlugin<CalendarPluginPlugin>('CalendarPlugin', {
  web: () => import('./web').then((m) => new m.CalendarPluginWeb()),
});

export * from './definitions';
export { CalendarPlugin };
